const DEFAULT_GROUP_NAMES = {
  ORGANIZATION: 'Organization',
  CROSS_SEGMENTED: 'New Cross-Segmented Group'
}

export { DEFAULT_GROUP_NAMES }
